import SelectedAssessment from "pages/PanelPage/components/selectedAssessment/SelectedAssessment/SelectedAssessment";

export default SelectedAssessment;
